import { AppInsightsContext } from '@shared/components/AppTelemetry/AppTelemetryProvider';
import LayoutContainer from '@shared/components/Layout/LayoutContainer';
import UserNotActive from '@shared/components/UserNotActive/UserNotActive';
import { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import styles from './index.module.scss';

export default function UserNotActivePage() {
    const { logPageView } = useContext(AppInsightsContext);

    useEffect(() => {
        logPageView('User Not Active Page');
    }, [logPageView]);

    return (
        <>
            <Helmet>
                <title>User Not Active | CarMax Auctions</title>
            </Helmet>
            <LayoutContainer hideSubHeader includeFooter>
                <div className={styles['page-container']}>
                    <UserNotActive />
                </div>
            </LayoutContainer>
        </>
    );
}
